// extracted by mini-css-extract-plugin
module.exports = {"partnerContainer":"_3TO0fLf_p68-FhQkKuV3v7","partnerIcon":"_2CxrpqgISLy5cMRoIThsHZ","viewMoreBtn":"_2ARkvE6T13uwfzde3jBfPD"};